import React from 'react';
import ReactDOM from 'react-dom/client';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import './index.css';
import App from './App.js';

// 지도 범례와 사이드바가 일반 MUI 기본값보다 높은 z-index를 사용한다.
// MUI 메뉴·다이얼로그·날짜 선택기·툴팁은 포털로 body에 렌더링되므로,
// 이 기준을 한 번에 올려야 뒤에 가려져 포커스만 남는 문제가 재발하지 않는다.
const appTheme = createTheme({
  zIndex: {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 31000,
    snackbar: 32000,
    tooltip: 33000,
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ThemeProvider theme={appTheme}>
    <App /> {/* StrictMode 제거 */}
  </ThemeProvider>
);


